import { createContext } from "react";

export type ClientContextState = {
  isClient: boolean;
};

export const ClientContext = createContext<ClientContextState>(
  {} as ClientContextState,
);
